// Auto-generated by scripts/build-dicts.mjs — DO NOT EDIT
export const CHUNK_5_WORDS: Record<number, string> = {
  5: "gyppo",
  6: "gyppos|wigger",
  7: "poofier|raghead|spazzed|wiggers",
  8: "poofiest|ragheads|spazzing",
  10: "bogtrotter|harelipped|piccaninny",
  11: "bogtrotters",
  12: "piccaninnies|teleprompter",
  13: "microfilarias|teleprompters"
};
